
import { Component, Vue } from 'vue-property-decorator'
import UserList from '@/components/user/UserList.vue'

@Component({
  name: 'Users',
  components: { UserList }
})
class Users extends Vue {}

export default Users
